import { createReducer, on } from "@ngrx/store";
import { HolidayGroup } from "../../models/holiday-group";
import { loadHolidayGroupByIdAct, resetHolidayGroupAct, saveSuccessHolidayGroupAct, setViolationsHolidayGroupAct, updateSuccessHolidayGroupAct } from "./holidays.action";

const holidayGroup: HolidayGroup = new HolidayGroup();

export const holidayGroupReducer = createReducer (
    {
        holidayGroup,
        violations: {},
        loading: true
    },
    on(resetHolidayGroupAct, (state) => ({
        holidayGroup:  { ...holidayGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadHolidayGroupByIdAct, (state, { holidayGroup }) =>({
        holidayGroup: { ...holidayGroup}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessHolidayGroupAct, (state, { holidayGroupNew }) => ({
        holidayGroup: { ...holidayGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessHolidayGroupAct, (state, { holidayGroupUpdated }) => ({
        holidayGroup: { ...holidayGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsHolidayGroupAct, (state, { holidayGroupForm, violations }) => ({
        holidayGroup: { ...holidayGroupForm },
        violations: {...violations},
        loading: false
    })),
)